<div class="container-fluid">

  <cli-landing-header></cli-landing-header>


  <div class="row">
    <div class="col"></div>
    <div class="col-md-12 col-lg-10 col-xl-8">


      <div class="row">

        <div class="col-3 pt-4">
          <cli-landing-menu></cli-landing-menu>
        </div>

        <div class="col-9">
          <div class="welcome-text pt-2 pb-4">
            Welcome to Hydrotrak
          </div>
          <div style="font-size:0.8rem">
            <p>
              South East Water is collecting the information requested on this form from you for the purpose of
              providing
              goods
              and services to you and monitoring and improving those goods and services.
            </p>
            <p>
              Without all or part of this information, the goods and services may not be provided to you.
            </p>
            <p>
              South East Water will handle this information in accordance with its legal obligations.
            </p>
            <p>
              You may obtain access to the information on request.
            </p>
            <p>
              The information may be disclosed to third parties in relation to the provision of the goods and services,
              including to South East Water's contractors assisting it in the provision of these goods and services to
              you,
              Melbourne Water, the Minister or the Environment Protection Authority.
            </p>
            <p>
              For a copy of South East Water's privacy statement which describes in more detail how personal information
              may
              be
              used by it, or details on how to access your personal information, see the web site at <a
                href="www.southeastwater.com.au">www.southeastwater.com.au</a> or contact <b>131 694</b>.
            </p>
          </div>
          <div class="d-flex pb-4">
            <div class="pr-4">
              <button type="button" class="btn btn-small btn-primary" (click)="newapplication()">New Permit Application</button>
            </div>
            <div>
              <button type="button" class="btn btn-small btn-primary" (click)="login()">Existing Customer Sign In</button>
            </div>
          </div>
        </div>


      </div>


    </div>
    <div class="col"></div>
  </div>




  <cli-landing-footer></cli-landing-footer>
</div>